import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AgentDashboard from './pages/agent-dashboard';
import CallHistoryPage from './pages/call-history';
import ContactDirectory from './pages/contact-directory';
import SupervisorMonitor from './pages/supervisor-monitor';
import SystemSettings from './pages/system-settings';
import CallAnalytics from './pages/call-analytics';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<AgentDashboard />} />
        <Route path="/agent-dashboard" element={<AgentDashboard />} />
        <Route path="/call-history" element={<CallHistoryPage />} />
        <Route path="/contact-directory" element={<ContactDirectory />} />
        <Route path="/supervisor-monitor" element={<SupervisorMonitor />} />
        <Route path="/system-settings" element={<SystemSettings />} />
        <Route path="/call-analytics" element={<CallAnalytics />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
